import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import BillToCompanyMappingContMain from "presentation/view/container/BillToCompanyMapping/BillToCompanyMappingContMain";

CommonEntrypoint(<BillToCompanyMappingContMain/>)